import React from "react";
import { Block, Button, Form, Modal } from "react-bulma-components";

export default function FormModal({ children, onClose, onSubmit, show, title }) {
    return (
        <Modal closeOnBlur closeOnEsc onClose={ onClose } show={ show }>
            <Modal.Card>
                <Modal.Card.Header>
                    <Modal.Card.Title>{ title }</Modal.Card.Title>
                </Modal.Card.Header>
                <Modal.Card.Body>
                    <Block>
                        { children }
                    </Block>
                </Modal.Card.Body>
                <Modal.Card.Footer>
                    <Form.Field kind="group">
                        <Form.Control>
                            <Button color="link" onClick={ onSubmit }>
                                Save
                            </Button>
                        </Form.Control>

                        <Form.Control>
                            <Button color="link" colorVariant="light" onClick={ onClose }>
                                Cancel
                            </Button>
                        </Form.Control>
                    </Form.Field>
                </Modal.Card.Footer>
            </Modal.Card>
        </Modal>
    );
}